import { JDSSkeletonProps } from './generated';

export interface SkeletonProps extends Omit<JDSSkeletonProps, 'width'> {
  width?: string;
  custom?: string;
  animated?: boolean;
  __noCustomWarn__?: boolean;
}

export const withLogic =
  (Component: React.ComponentType<SkeletonProps>): React.FC<SkeletonProps> =>
  (props: SkeletonProps) => {
    if (props.shape === 'custom' && !props.__noCustomWarn__) {
      console.warn('shape=custom is an internal variant. Please do not use it');
    }
    return (
      <Component
        {...{
          ...props
        }}
        width={props.width}
      />
    );
  };
